import binIcon from './assets/bin-embedded.svg';

export default {
  components: {
    binIcon,
  },
  props: {
    title: {
      type: String,
    },
    name: {
      type: String,
    },
    amount: {
      type: String,
    },
    isEditing: {
      type: Boolean,
      default: false,
    },
    onEdit: {
      type: Function,
      required: true,
    },
    onRemove: {
      type: Function,
      required: true,
    },
  },
};
